<form [formGroup]="form" appearance="outline">
  <mat-form-field appearance="outline" class="country-field">
    <input
      matInput
      [formControl]="form.controls.country"
      class="surface-text"
      [matAutocomplete]="auto"
    />
    <div class="input-display"></div>
    <mat-autocomplete #auto="matAutocomplete" [panelWidth]="200">
      @for (config of countryConfigs; track config.code) {
        <mat-option [value]="config.shortDisplay">
          {{ config.shortDisplay }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field
    appearance="outline"
    class="phone-number-field"
    floatLabel="always"
  >
    <mat-label>Phone</mat-label>
    <mat-icon matPrefix class="on-surface-text">phone</mat-icon>
    <input
      matInput
      inputmode="numeric"
      [formControl]="form.controls.phoneNumber"
      #phoneInput
    />
  </mat-form-field>
</form>
